export default __webpack_public_path__ + "static/media/ruby.c053817d.svg";